const REASONS = [
  {
    number: "01",
    title: "Practitioner, not pundit.",
    description: "Built and sold companies, shipped products, trained teams.",
  },
  {
    number: "02",
    title: "One of India's most-followed AI voices.",
    description: "4M+ reach across LinkedIn, Twitter, newsletter.",
  },
  {
    number: "03",
    title: "Audiences leave with something to use.",
    description:
      "Frameworks, prompts, and mental models they can apply Monday.",
  },
  {
    number: "04",
    title: "No fluff. No hype.",
    description: "Clear language, real examples, honest about limits.",
  },
] as const;

export default function WhyInvite() {
  return (
    <section className="w-full bg-black py-8 md:py-14 font-fira text-white sm:py-20">
      <div className="mx-auto w-[90%] md:w-[80%]">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:items-start md:gap-12 lg:gap-16">
          <header className="text-left">
            <p className="mb-4 text-xs font-normal uppercase tracking-[1.75px] text-white/80 md:text-sm">
              Why invite Vaibhav
            </p>
            <h2 className="mb-4 font-fira-condensed text-[30px] font-medium leading-tight tracking-tight text-white md:text-[42px]">
              Your audience has heard the AI pitch. This is different.
            </h2>
            <p className="text-[14px] font-normal leading-relaxed text-[#FFFFFF85] md:text-[16px]">
              Every speaker promises insights. Most deliver theory. Vaibhav
              brings what&apos;s actually working—tested, practical, and
              grounded in real use.
            </p>
          </header>

          <ul className="overflow-hidden rounded-2xl border border-white/10">
            {REASONS.map((reason, idx) => (
              <li
                key={reason.number}
                className={`flex items-start gap-5 p-5 md:gap-6 md:p-6 ${
                  idx % 2 === 1 ? "bg-[#161614]" : "bg-transparent"
                } ${idx > 0 ? "border-t border-white/10" : ""}`}
              >
                <span className="shrink-0 text-sm font-normal text-white/40 md:text-base">
                  {reason.number}
                </span>
                <div className="flex flex-col gap-1.5">
                  <h3 className="text-[15px] font-semibold leading-snug text-white md:text-base">
                    {reason.title}
                  </h3>
                  <p className="text-sm font-normal leading-relaxed text-white/60 md:text-[15px]">
                    {reason.description}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
